// extracted by mini-css-extract-plugin
export default {"center":"Interaction_center__d5ttV","interact":"Interaction_interact__0skyF"};